import { render, staticRenderFns } from "./MediacontactEdit.vue?vue&type=template&id=639f32f7"
import script from "./MediacontactEdit.vue?vue&type=script&lang=js"
export * from "./MediacontactEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports